<template>
  <b-modal
    id="new_nfse"
    title="Emitir nota fiscal"
    hide-footer
    size="lg"
    @show="onShow"
    @hidden="onHidden"
    no-close-on-backdrop
  >
    <div class="nfse-form">
      <ErrorsMessages :errors="errors" />

      <!-- Residente -->
      <div class="field-group">
        <label class="field-label">Residente</label>
        <v-autocomplete
          v-model="resident_id"
          :items="residents"
          item-text="name"
          item-value="id"
          placeholder="Selecione o residente"
          outlined
          dense
          hide-details
          class="modern-input"
          @change="onResidentChange"
        />
      </div>

      <b-overlay :show="loadingCustomer" opacity="0.6">
        <!-- Tomador (responsável financeiro) -->
        <div class="section-title">Tomador (quem recebe a nota)</div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Nome / Razão social</label>
            <v-text-field
              v-model="tomador.name"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">CPF/CNPJ</label>
            <v-text-field
              v-model="tomador.document"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">E-mail</label>
            <v-text-field
              v-model="tomador.email"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group field-group-wide">
            <label class="field-label">Logradouro</label>
            <v-text-field
              v-model="tomador.address.street"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Número</label>
            <v-text-field
              v-model="tomador.address.number"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Bairro</label>
            <v-text-field
              v-model="tomador.address.district"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">CEP</label>
            <v-text-field
              v-model="tomador.address.zipcode"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">UF</label>
            <v-text-field
              v-model="tomador.address.state"
              outlined
              dense
              hide-details
              class="modern-input"
            />
          </div>
        </div>
      </b-overlay>

      <!-- Serviço -->
      <div class="section-title">Serviço</div>

      <div class="field-row">
        <div class="field-group">
          <label class="field-label">Valor (R$)</label>
          <v-text-field
            v-model="service_value"
            type="number"
            step="0.01"
            outlined
            dense
            hide-details
            class="modern-input"
          />
        </div>
        <div class="field-group">
          <label class="field-label">Código do serviço</label>
          <v-text-field
            v-model="service_code"
            placeholder="Usa o padrão da configuração se em branco"
            outlined
            dense
            hide-details
            class="modern-input"
          />
        </div>
      </div>

      <div class="field-row">
        <div class="field-group field-group-wide">
          <label class="field-label">Descrição do serviço</label>
          <v-text-field
            v-model="service_description"
            placeholder="Usa o padrão da configuração se em branco"
            outlined
            dense
            hide-details
            class="modern-input"
          />
        </div>
      </div>

      <div class="form-actions">
        <v-btn class="btn-cancel-modern" @click="$bvModal.hide('new_nfse')">
          Cancelar
        </v-btn>
        <v-btn class="btn-add-modern" :loading="saving" @click="handleSubmit">
          <i class="fas fa-paper-plane mr-2"></i>
          Emitir
        </v-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import api from "../../services/api";

export default {
  name: "NewNfse",
  components: { ErrorsMessages },
  data() {
    return {
      residents: [],
      resident_id: null,
      loadingCustomer: false,
      saving: false,
      errors: [],
      service_value: null,
      service_code: "",
      service_description: "",
      customer_id: null,
      tomador: {
        name: "",
        document: "",
        email: "",
        address: {
          street: "",
          number: "",
          complement: "",
          district: "",
          zipcode: "",
          city_ibge_code: "",
          state: "",
        },
      },
    };
  },
  methods: {
    async onShow() {
      this.resetForm();
      await this.loadResidents();
    },

    onHidden() {
      this.resetForm();
    },

    resetForm() {
      this.resident_id = null;
      this.customer_id = null;
      this.service_value = null;
      this.service_code = "";
      this.service_description = "";
      this.errors = [];
      this.tomador = {
        name: "",
        document: "",
        email: "",
        address: {
          street: "",
          number: "",
          complement: "",
          district: "",
          zipcode: "",
          city_ibge_code: "",
          state: "",
        },
      };
    },

    async loadResidents() {
      try {
        const response = await api.get("/rest-home/active-residents");
        const { error, residents } = response.data;
        if (!error) this.residents = residents || [];
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Ao escolher o residente, busca o responsável financeiro cadastrado
     * (customer) para pré-preencher o tomador — evita digitar tudo de novo.
     * OBS: a resposta exata desse endpoint precisa ser conferida no projeto;
     * se os nomes de campo vierem diferentes do esperado aqui, ajustar o
     * mapeamento abaixo (ficou com fallback silencioso para não travar
     * o preenchimento manual caso a estrutura seja outra).
     */
    async onResidentChange(residentId) {
      if (!residentId) return;

      try {
        this.loadingCustomer = true;

        const response = await api.get("/rest-home/customer/by-resident", {
          params: { resident_id: residentId },
        });

        const { error, customer } = response.data;

        if (!error && customer) {
          this.customer_id = customer.id || null;
          this.tomador.name = customer.name || this.tomador.name;
          this.tomador.document =
            customer.document || customer.cpf || this.tomador.document;
          this.tomador.email = customer.email || this.tomador.email;

          if (customer.address) {
            this.tomador.address = {
              street: customer.address.street || "",
              number: customer.address.number || "",
              complement: customer.address.complement || "",
              district: customer.address.district || "",
              zipcode: customer.address.zipcode || "",
              city_ibge_code: customer.address.city_ibge_code || "",
              state: customer.address.state || "",
            };
          }
        }

        this.loadingCustomer = false;
      } catch (error) {
        // não bloqueia o formulário — usuário preenche manualmente
        console.log(error);
        this.loadingCustomer = false;
      }
    },

    async handleSubmit() {
      try {
        this.saving = true;
        this.errors = [];

        const payload = {
          resident_id: this.resident_id,
          customer_id: this.customer_id,
          service_value: this.service_value,
          service_code: this.service_code || undefined,
          service_description: this.service_description || undefined,
          tomador: this.tomador,
        };

        const response = await api.post("/rest-home/nfse", payload);
        const { error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_nfse");
          this.$emit("created");
        }

        this.saving = false;
      } catch (error) {
        console.log(error);
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.nfse-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  color: #1b4965;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e7eb;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-group-wide {
  grid-column: span 1;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.btn-cancel-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.modern-input >>> .v-input__control {
  border-radius: 8px !important;
}
</style>